import { render, staticRenderFns } from "./validPass.vue?vue&type=template&id=484fba18&scoped=true&"
import script from "./validPass.vue?vue&type=script&lang=js&"
export * from "./validPass.vue?vue&type=script&lang=js&"
import style0 from "./validPass.vue?vue&type=style&index=0&id=484fba18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484fba18",
  null
  
)

export default component.exports